const ObjectPrivileges = [
  'visible',
  'write',
  'writeData',
  'structure',
  'manage',
  'execute',
  'share',
  'delete',
  'visibleRestricted',
  'changeOwner',
  'modifyContent',
  'modifyAll',
  'createObjecttype',
  'modify'
] as const;

/**
 * Privileges that apply to repository items.
 * The Java enum is named ObjectPrivilege because it is a legacy from the old access management.
 * In the context of the new AMW on the front-end we have the advantage to be able to use a better name.
 *
 * @see ObjectPrivilege.java
 */
export type ObjectPrivilege = typeof ObjectPrivileges[number];

/**
 * @deprecated Use the type instead.
 */
export const ObjectPrivilege = Object.fromEntries(ObjectPrivileges.map(p => [ p, p ]));

/**
 * Check whether the given privileges include one of the privileges to check.
 *
 * @param privileges
 * @param privilegesToCheck
 * @return Whether one of the privileges is included
 */
export function hasPrivilege (
  privileges: ObjectPrivilege[] | null,
  ...privilegesToCheck: ObjectPrivilege[]
): boolean {
  return privileges != null && privilegesToCheck.some(privilege => privileges.includes(privilege));
}

export function hasModifyPrivilege (privileges: ObjectPrivilege[] | null) {
  return hasPrivilege(privileges, 'modify');
}

export function hasWritePrivilege (privileges: ObjectPrivilege[] | null) {
  return hasPrivilege(privileges, 'write');
}
